import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import useApiHelper from "../../hooks/useApiHelper";
import { IPartCategory } from "../../models/Category/Category";
import { IDefaultResponse } from "../../models/DefaultResponse";
import { CategoryQueryKeys } from "./keys";

export default function useCategorySingle(categoryId: string | undefined) {
  const { get, post, put, del } = useApiHelper();
  const queryClient = useQueryClient();

  const category = useQuery({
    queryKey: CategoryQueryKeys.single(categoryId),
    queryFn: () => get<IDefaultResponse<IPartCategory>>(`/part/categories/${categoryId}`).then(
      (res) => res.data,
    ),
    enabled: !!categoryId,
  });

  const create = useMutation({
    mutationFn: (category: IPartCategory) => post(`/part/categories`, category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CategoryQueryKeys.all() });
    },
  });

  const update = useMutation({
    mutationFn: (category: IPartCategory) => put(`/part/categories/${category.id}`, category),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: CategoryQueryKeys.all() });
    },
  });

  //Not implemented on API
  // const bulkUpdatePartCategories = useMutation({
  //   mutationFn: (body: any) => post(`/part/categories/bulk`, body),
  //   onSuccess: () => {
  //     queryClient.invalidateQueries({ queryKey: CategoryQueryKeys.all() });
  //   },
  // });

  return {
    category,
    create,
    update,
    // bulkUpdatePartCategories,
  };
}
